


const initialState = {
  workbenchData: {
    count: 0,
    results: [],
  },
};
interface Action {
  type: string;
  payload?: any;
}

const workbenchReducer = (state = initialState, action: Action) => {

  switch (action.type) {
    case "UPDATE_WORKBENCH_DATA":
      return {
        ...state,
        workbenchData: action.payload,
      };
    default:
      return state;
  }
};

export default workbenchReducer;